export default "__VITE_ASSET__Ccjml40X__"